import script from "./img.vue?vue&type=script&setup=true&lang=ts"
export * from "./img.vue?vue&type=script&setup=true&lang=ts"

import "./img.vue?vue&type=style&index=0&id=218ab200&lang=scss&scoped=true"

import exportComponent from "/Users/bear/Desktop/项目/隆鑫公司/茵Wie/bicose-customer-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218ab200"]])

export default __exports__